import { MESSAGES } from '../CommonConstants';
import fetchWithDefaults from '../CommonUtils/fetchWithDefaults';
import { httpBodyOptions } from '../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../CommonUtils/urlWithParams';

export const ERRORS_SET = 'INSTITUTION_AUTOCOMPLETE.ERRORS_SET';
export const INSTITUTIONS_SET = 'INSTITUTION_AUTOCOMPLETE.INSTITUTIONS_SET';
export const IS_LOADING_SET = 'INSTITUTION_AUTOCOMPLETE.IS_LOADING_SET';

export const SET_TERM_QUERY = 'INSTITUTION_AUTOCOMPLETE.SET_TERM_QUERY';

export const setIsLoading = payload => ({
  type: IS_LOADING_SET,
  payload,
});

export const setInstitutions = payload => ({
  type: INSTITUTIONS_SET,
  payload,
});

export const setErrors = payload => ({
  type: ERRORS_SET,
  payload,
});

export const setTermQuery = payload => ({
  type: SET_TERM_QUERY,
  payload,
});

export const fetchInstitutions = (clientId, term) => async dispatch => {
  dispatch(setIsLoading(true));

  try {
    const response = await fetchWithDefaults(
      urlWithParams('/Consumer/AutoComplete/ListInstitutions', { clientId }),
      { method: 'POST', ...httpBodyOptions({ term }) },
    );

    const { success, payload, errors } = await response.json();

    if (success) {
      const formattedInstitutions = payload.viewData.Data.map(result => ({
        label: result.Term,
        value: result.Value,
      }));

      dispatch(setInstitutions(formattedInstitutions));
    } else {
      dispatch(setErrors(errors));
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    dispatch(setErrors([MESSAGES.GENERIC_ERROR]));
  } finally {
    dispatch(setIsLoading(false));
  }
};
